module.exports = __webpack_public_path__ + "globe-green.3d1b2ec95477cef1158fc1b37c7c4301.svg";